import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./app.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./app.component.scss?ngResource";
import { Component } from "@angular/core";
import { AuthService } from "./shared/services/auth/auth.service";
import { LoginService } from "./shared/services/login/login.service";
import { AppControllerService } from "./app-controller.service";
import { WindowReference } from "./shared/classes/window-reference";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { PwaInstallBottomSheetComponent } from "./shared/components/pwa-install-bottom-sheet/pwa-install-bottom-sheet.component";
import { take, takeUntil } from "rxjs/operators";
import { SubscriberComponent } from "./shared/components/subscriber/subscriber.component";
import { UserInformationService } from "./shared/services/user/user-information.service";
import { AppConfig } from "./app.config";
import { RequestStatusService } from "./shared/services/request-status/request-status.service";
import { SystemModuleSettingsService } from "./shared/services/system-module-settings.service";
import { ServerNotificationService } from "./shared/services/server-notification/server-notification.service";
import { WebNotificationService } from "./shared/services/web-notification/web-notification.service";
import { Router } from "@angular/router";
import { LocalStorageEnum } from "./shared/services/storage/local-storage-constants";
import { LocalStorageService } from "./shared/services/storage/local-storage.service";
import { SessionStorageEnum } from "./shared/services/storage/session-storage-constants";
import { SessionStorageService } from "./shared/services/storage/session-storage.service";
import { LandingPageService } from "./core/landing-page/shared/services/landing-page.service";
export let AppComponent = class AppComponent extends SubscriberComponent {
    appController;
    authService;
    loginService;
    sessionStorageService;
    windowReference;
    bottomSheet;
    landingPageService;
    userInformationService;
    appConfig;
    requestStatusService;
    systemModuleSettingsService;
    serverMessageService;
    webNotificationService;
    router;
    localStorage;
    mapCenter = [-122.4194, 37.7749];
    basemapType = "satellite";
    mapZoomLevel = 12;
    $isAuthenticated;
    $userInformationFetched;
    showBusyIndicator = false;
    showLandingPage = false;
    deferredPromptEvent;
    ON_SAME_RELOAD_STRATEGY = "reload";
    constructor(appController, authService, loginService, sessionStorageService, windowReference, bottomSheet, landingPageService, userInformationService, appConfig, requestStatusService, systemModuleSettingsService, serverMessageService, webNotificationService, router, localStorage) {
        super();
        this.appController = appController;
        this.authService = authService;
        this.loginService = loginService;
        this.sessionStorageService = sessionStorageService;
        this.windowReference = windowReference;
        this.bottomSheet = bottomSheet;
        this.landingPageService = landingPageService;
        this.userInformationService = userInformationService;
        this.appConfig = appConfig;
        this.requestStatusService = requestStatusService;
        this.systemModuleSettingsService = systemModuleSettingsService;
        this.serverMessageService = serverMessageService;
        this.webNotificationService = webNotificationService;
        this.router = router;
        this.localStorage = localStorage;
        this.$userInformationFetched = this.userInformationService.$userInformationFetched;
        this.$isAuthenticated = this.authService.$isAuthenticated;
        this.saveUrl();
        this.listenForLandingPageLogin();
        this.startAuthenticationProcess();
        this.setupPwaInstall(windowReference);
    }
    ngOnInit() {
        this.listenForBusySpinnerChanges();
        this.setRouterReloadStrategy();
    }
    saveUrl() {
        this.router.events.pipe(take(1)).subscribe((event) => {
            if (!this.localStorage.get(LocalStorageEnum.Url)) {
                this.localStorage.set(LocalStorageEnum.Url, event.url);
            }
        });
    }
    startAuthenticationProcess() {
        this.loadAppConfig(() => {
            const localStorageIsAuthenticated = this.sessionStorageService.get(SessionStorageEnum.Nonce);
            if (!localStorageIsAuthenticated) {
                this.showLandingPage = true;
            }
            else if (this.router.url.includes("/logout")) {
                this.authService.unAuthenticateFrontChannel();
            }
            else {
                this.showLandingPage = false;
                if (this.authService.checkIfLoggedIn()) {
                    this.authService.configureAuth();
                    this.showLandingPage = false;
                }
                else {
                    this.authenticate();
                }
            }
        });
    }
    loadAppConfig(appConfigLoadedAction) {
        this.appConfig.load().then(() => {
            appConfigLoadedAction();
        });
    }
    authenticate() {
        this.authService.authenticate().then((result) => {
            this.handleUserLoggedIn();
        });
    }
    setupPwaInstall(windowReference) {
        windowReference.nativeWindow.addEventListener("beforeinstallprompt", (event) => {
            event.preventDefault();
            this.deferredPromptEvent = event;
            const bottomSheetRef = this.bottomSheet.open(PwaInstallBottomSheetComponent);
            bottomSheetRef.afterDismissed()
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe((result) => {
                if (result) {
                    this.promptInstallPWA();
                }
            });
        });
    }
    promptInstallPWA() {
        this.deferredPromptEvent.prompt();
    }
    listenForBusySpinnerChanges() {
        this.requestStatusService.$requestBusy.subscribe(value => {
            this.showBusyIndicator = value;
        });
    }
    handleUserLoggedIn() {
        this.listenForServerMessages();
    }
    listenForServerMessages() {
        this.cleanupAfterDestroy(this.serverMessageService.messageReceived).subscribe((message) => {
            this.webNotificationService.showNotification("Message received", message);
        });
    }
    setRouterReloadStrategy() {
        this.router.onSameUrlNavigation = this.ON_SAME_RELOAD_STRATEGY;
    }
    listenForLandingPageLogin() {
        this.landingPageService.loginButtonClicked.subscribe({
            next: (isLoginButtonClicked) => {
                if (isLoginButtonClicked) {
                    this.authenticate();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: AuthService },
        { type: LoginService },
        { type: SessionStorageService },
        { type: WindowReference },
        { type: MatBottomSheet },
        { type: LandingPageService },
        { type: UserInformationService },
        { type: AppConfig },
        { type: RequestStatusService },
        { type: SystemModuleSettingsService },
        { type: ServerNotificationService },
        { type: WebNotificationService },
        { type: Router },
        { type: LocalStorageService }
    ];
};
AppComponent = __decorate([
    Component({
        selector: "app-root",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], AppComponent);
